const _ = require("lodash");

function settingsDuration() {
    let ret = 15;
    let val = localStorage.getItem("droopy.duration");
    if (val) {
        ret = parseInt(val);
        if (ret < 1 || ret > 60) {
            ret = 15;
        }
    }
    return ret;
}

function getLocalStorage(key, ifKeyVal, thenRet, elseRet) {
    key = "droopy." + key;
    if (localStorage.getItem(key) === ifKeyVal) return thenRet;
    return elseRet;
}

function setLocalStorage(key, val) {
    localStorage.setItem(key, val ? "yes" : "no");
}

function save(obj, prefix) {
    Object.keys(obj).forEach(k => {
        if (typeof obj[k] === "object") {
            save(obj[k], k);
        } else {
            let key = "droopy." + (prefix ? prefix + "." + k : k);
            if (typeof obj[k] === "boolean") {
                localStorage.setItem(key, obj[k] ? "yes" : "no");
            } else {
                localStorage.setItem(key, obj[k]);
            }
        }
    });
}

let SETTINGS = {
    game: {
        "is-to-Nfr": getLocalStorage("game.is-to-Nfr", "no", false, true),
        "fr-to-Nis": getLocalStorage("game.fr-to-Nis", "no", false, true),
        "is-to-fr": getLocalStorage("game.is-to-fr", "no", false, true),
        "fr-to-is": getLocalStorage("game.fr-to-is", "no", false, true),
        path: getLocalStorage("game.path", "no", false, true),
        spell: getLocalStorage("game.spell", "no", false, true),
        syllables: getLocalStorage("game.syllables", "no", false, true),
        hole: getLocalStorage("game.hole", "no", false, true),
    },
    duration: settingsDuration(),
    onlyMultiword: getLocalStorage("onlyMultiword", "yes", true, false),
    onlyEg: getLocalStorage("onlyEg", "yes", true, false),
}

function get() {
    return _.cloneDeep(SETTINGS);
}

function set(settings) {
    SETTINGS = _.cloneDeep(settings);
    save(settings);
}

module.exports = {
    get,
    set
};

